import React, { useEffect, useMemo } from 'react';
import { makeStyles } from "@material-ui/core";
import { SORTING_TYPES as sort } from "../../../utils/js/constants";
import Layout from "../../Layout/Layout";
import { balanceSheetStyle } from "./balanceSheetStyle";
import { bindActionCreators } from "redux";
import { Creators as ProductActions } from "../../../store/ducks/products";
import { connect } from "react-redux";
import { sortAndFilterProducts } from "../../../api/services/productService";

const useStyles = makeStyles((theme) => balanceSheetStyle(theme));

const BalanceSheet = ({ getProductList, produtos }) => {
  const classes = useStyles();

  const [listProducts, setListProducts] = React.useState([]);

  const { data, type } = produtos;

  useEffect(() => {
    if (!listProducts.length) {
      getProductList();
    }
  }, [getProductList, listProducts])

  useEffect(() => {
    if (type === "products/SEARCH_ALL") {
      setListProducts(sortAndFilterProducts(data, sort.NOME, false))
    }
  }, [data, type]);

  const renderHeader = (
    <div className={classes.header}>
      <div className={classes.card}>
        <p className={classes.productName}>NOME DO PRODUTO</p>
        <p className={classes.productStock}>ESTOQUE ATUAL</p>
        <p className={classes.productAmount}>VALOR TOTAL</p>
      </div>
    </div>
  )

  const renderProduct = ({ nome, estoque_atual, preco }) => (
    <div className={classes.card}>
      <p className={classes.productName}>{nome.toUpperCase()}</p>
      <p className={classes.productStock}>{estoque_atual}</p>
      <p className={classes.productAmount}>R$ {(estoque_atual * preco).toFixed(2).replace('.', ',')}</p>
    </div>
  )

  const reducePriceProducts = products => products.reduce((acc, { estoque_atual, preco }) => acc + estoque_atual * preco, 0)

  const reduceStockProducts = products => products.reduce((acc, { estoque_atual }) => acc + estoque_atual, 0)

  const parseToMoney = (value = 0) => {
    let fixedVal = value.toFixed(2).replace('.', ',');

    return 'R$ ' + fixedVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

  const renderBalance = useMemo(() => (
    <div className={classes.box}>
      <p className={classes.boxTitle}>Balanço do Dia</p>
      <div>
        <p className={classes.boxTitle}>{parseToMoney(reducePriceProducts(listProducts))}</p>
        <p className={classes.boxSubtitle}>{reduceStockProducts(listProducts)} produtos</p>
      </div>
    </div>
  ), [listProducts])

  return (
    <div className={classes.root}>
      <Layout title="Balanço Patrimonial">
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {renderBalance}

          {renderHeader}
          {listProducts.map(renderProduct)}
        </main>
      </Layout>
    </div>
  );
}

const mapStateProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ProductActions, dispatch);
};

export default connect(mapStateProps, mapDispatchToProps)(BalanceSheet);
